import { render, staticRenderFns } from "./center.vue?vue&type=template&id=620dd21c&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&id=620dd21c&prod&lang=scss&"
import style1 from "./center.vue?vue&type=style&index=1&id=620dd21c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dd21c",
  null
  
)

export default component.exports